// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj } from '..'
import { vcBaseUrl } from '.'


type ValidateSessionResponse = (SuccessResponse & {
    status: string
    token: string
}) | FailedResponse

export class ValidateSessionRequest extends Request {
    private constructor(init?: RequestInit) { super(`${vcBaseUrl}/session/validate`, init) }
    static async init(body: {}, init?: RequestInit) {
        return new ValidateSessionRequest({
            ...init,
            method: 'POST',
            credentials: 'include',
            body: JSON.stringify(body),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<{ response: Response, data: ValidateSessionResponse }> {
        const response = await fetch(this)
        const data = createResponseObj<ValidateSessionResponse>(await response.json())
        console.info("Validate Session Results:", data)

        switch (data.status) {
            case 'successful':
            case 'failed': return { response, data }
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}
